"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isiOS = void 0;

var isiOS = function isiOS() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) // iPad on iOS 13 detection
  || navigator.userAgent.includes("Mac") && "ontouchend" in document;
};

exports.isiOS = isiOS;